import {useMemo} from "react";
import {Box, CircularProgress, useTheme} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";
import {esES} from "@mui/x-data-grid/locales";
import styles from "./ListView.module.css";
import {DEFAULT_PAGE_SIZE_OPTIONS, DEFAULT_PAGINATION} from "../../utils/pagination";

const ListView = ({
  columns,
  data = [],
  topRightButtons,
  loading,
  onRowClick,
  getRowId,
  getRowClassName,
  dataGridProps = {}
}) => {
  const theme = useTheme();

  const rows = useMemo(() => {
    return Array.isArray(data) ? data : data?.data || [];
  }, [data]);

  const flexColumns = useMemo(() => {
    return columns.map((col) => {
      /*if (col.width || col.flex) {
        return col;
      }*/

      if (col.field === "actions") {
        return {
          ...col,
          width: 100,
          align: "center",
          headerAlign: "center"
        };
      }

      return {
        ...col,
        flex: col.flex ?? 1,
        minWidth: col.minWidth ?? 150
      };
    });
  }, [columns]);

  return (
    <>
      {loading ? (
        <CircularProgress size={300} color={theme.palette.colors.primary} />
      ) : (
        <Box
          className={styles.container}
          style={{
            backgroundColor: theme.palette.card.background,
            borderRadius: theme.palette.card.borderRadius,
            boxShadow: theme.palette.card.borderShadow,
            border: `1px solid ${theme.palette.card.border}`
          }}
        >
          {topRightButtons && <header className={styles.header}>{topRightButtons}</header>}
          <DataGrid
            rows={rows}
            columns={flexColumns}
            pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
            {...dataGridProps}
            sortingOrder={["asc", "desc"]}
            disableColumnFilter
            className={styles.dataGrid}
            slotProps={{
              pagination: {
                SelectProps: {
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        bgcolor: theme.palette.windowScreen.background,
                        "& .MuiMenuItem-root": {
                          color: theme.palette.text.primary
                        }
                      }
                    }
                  }
                }
              }
            }}
            sx={{
              border: "none",
              borderRadius: theme.palette.card.borderRadius,
              "& .MuiDataGrid-columnHeader": {
                paddingLeft: "20px",
                paddingRight: "20px",
                backgroundColor: theme.palette.listView.headerBackground,
                color: theme.palette.listView.headerText,
                fontWeight: "bold"
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: theme.palette.listView.rowHoverBackground
              },
              "& .MuiDataGrid-row.row-disabled": {
                backgroundColor: theme.palette.mode === "light" ? "#f8f8f8" : "#3a3a3a",
                color: theme.palette.mode === "light" ? "#999999" : "#888888",
                "& .MuiDataGrid-cell": {
                  color: theme.palette.mode === "light" ? "#999999" : "#888888"
                },
                "&:hover": {
                  backgroundColor: theme.palette.mode === "light" ? "#eeeeee" : "#414141"
                }
              },
              "& .MuiDataGrid-columnSeparator": {
                display: "none"
              },
              "& .MuiDataGrid-cell": {
                paddingLeft: "20px",
                paddingRight: "20px"
              },

              "& .MuiDataGrid-footerContainer .MuiTablePagination-root .MuiSelect-icon": {
                color: theme.palette.listView.headerText
              },

              "& .MuiDataGrid-footerContainer .MuiTablePagination-root .MuiIconButton-root": {
                color: theme.palette.listView.headerText
              }
            }}
            getRowId={getRowId}
            getRowClassName={getRowClassName}
            loading={loading}
            localeText={{
              ...esES.components.MuiDataGrid.defaultProps.localeText,
              MuiTablePagination: {
                labelRowsPerPage: "Filas por página:",
                labelDisplayedRows: ({from, to, count}) => `${from}–${to} de ${count !== -1 ? count : `más de ${to}`}`
              }
            }}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: DEFAULT_PAGINATION
                }
              },
              pinnedColumns: {right: ["actions"]}
            }}
            disableRowSelectionOnClick
            onRowClick={(params) => {
              if (onRowClick) {
                onRowClick(params.row);
              }
            }}
          />
        </Box>
      )}
    </>
  );
};

export default ListView;
